import { render, staticRenderFns } from "./JumlahPenerimaPenghargaanTimeseries.vue?vue&type=template&id=ba2d3eb8&"
import script from "./JumlahPenerimaPenghargaanTimeseries.vue?vue&type=script&lang=js&"
export * from "./JumlahPenerimaPenghargaanTimeseries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports